import { useAuth0 } from '@auth0/auth0-react';
import { useParams } from 'react-router';
import useSWR, { SWRResponse } from 'swr';
import http from '@/Utils/HTTP/NewHttpUtils';
import {
    ApplicantAssessmentStatusCounterResponse,
    DefaultApplicantAssessmentStatusCounterResponse,
} from './DTO/ApplicantAssessmentStatusCounterResponse';

const useApplicantAssessmentCounters = (): SWRResponse<ApplicantAssessmentStatusCounterResponse> => {
    const { getAccessTokenSilently } = useAuth0();
    const { assessmentId } = useParams();

    return useSWR(`recruitments/${assessmentId}/applicants-overview/counters`, async (path) => {
        const response = await http.get<ApplicantAssessmentStatusCounterResponse>({
            path,
            accessToken: await getAccessTokenSilently(),
        });

        return response || DefaultApplicantAssessmentStatusCounterResponse;
    });
};

export default useApplicantAssessmentCounters;
